import smile from "../assets/smile-icon.svg";
import city from "../assets/city.svg";
import properties from "../assets/properties.svg";
import exellent from "../assets/exellent.svg"
import recomended from "../assets/recomended.svg"
import apartments from "../assets/apartments.svg";
import locations from "../assets/location.svg";
import application from "../assets/locations.svg";
import inclusive from "../assets/inclusive.svg";
import assistance from "../assets/reservation.svg";
import flexibility from "../assets/chat.svg";
import stepOne from "../assets/location-choice.svg";
import stepTwo from "../assets/disponibilite.svg";
import stepThree from "../assets/payment.svg";
import stepFour from "../assets/confirm.svg";
import dax from "../assets/dax.jpg";
import mugron from "../assets/mugron.jpg";
import f1 from "../assets/flatmates/Groupe de masques 1.png";
import f2 from "../assets/flatmates/Groupe de masques 3.png";
import f3 from "../assets/flatmates/Groupe de masques 5.png";
import f4 from "../assets/flatmates/Groupe de masques 2.png";
import f5 from "../assets/flatmates/Groupe de masques 4.png";
import f6 from "../assets/flatmates/Groupe de masques 7.png";
import f7 from "../assets/flatmates/Groupe de masques 6.png";
import f8 from "../assets/flatmates/Groupe de masques 8.png";
import room_city from "../assets/bacdbb_723fc3ba38f34640b08464a29a8990c9_mv2-1.jpg"
import upload from "../assets/image-gallery.svg"
import payslip from "../assets/g2115.svg"
import certificate from "../assets/certificate.svg"
import groupId from "../assets/Groupe 1178.svg"
import inVoice from "../assets/invoice.svg"
import blog1 from "../assets/blog1.png"
import blog2 from "../assets/blog2.png"
import blog3 from "../assets/blog3.png"
import blog4 from "../assets/blog4.png"
import blog5 from "../assets/blog5.png"
import blog6 from "../assets/blog6.png"
import blogContent1 from "../assets/blog-content1.png"


export const NavTable = [
    {
        id: 1,
        href: ``, 
        name: "HOME"
    },
    {
        id: 2,
        href: "blog",
        name: "BLOG"
    },
    {
        id: 3,
        href: "contact",
        name: "CONTACT"
    },
    {
        id: 3,
        href: "faq",
        name: "FAQ"
    }
]
export const blogPosts = [
    {
      id: 1,
      date: 'Jun 07, 2022',
      title: "Célébrez le coup d'envoi de Paris 2024 sur la terrasse du musée d'Orsay",
      description: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum',
      imageUrl: blog1
    },
    {
      id: 2,
      date: 'Jun 12, 2024',
      title: 'Jeux Paralympiques de Paris 2024 : nos conseils pour réserver "last minute"',
      description: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum',
      imageUrl: blog2
    },
    {
      id: 3,
      date: 'Sep 22, 2024',
      title: 'Vacances d’été de dernière minute : voici nos meilleures astuces',
      description: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum',
      imageUrl: blog3
    },
    {
        id: 4,
        date: 'Jun 07, 2022',
        title: 'Célébrez le coup d’envoi de Paris 2024 sur la terrasse du musée d’Orsay',
        description: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum',
        imageUrl: blog4
      },
      {
        id: 5,
        date: 'Jun 12, 2024',
        title: 'Jeux Paralympiques de Paris 2024 : nos conseils pour réserver "last minute"',
        description: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum',
        imageUrl: blog5
      },
      {
        id: 6,
        date: 'Sep 22, 2024',
        title: "Vacances d'été de dernière minute : voici nos meilleures astuces",
        description: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum',
        imageUrl: blog6
      },
  ];
  export const blogContent = [
    {
        id: 1,
        imageUrl: blogContent1,
        content: `
        Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source. Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of "de Finibus Bonorum et Malorum" (The Extremes of Good and Evil) by Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular during the Renaissance. The first line of Lorem Ipsum, "Lorem ipsum dolor sit amet..", comes from a line in section 1.10.32. The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested. Sections 1.10.32 and 1.10.33 from "de Finibus Bonorum et Malorum" by Cicero are also reproduced in their exact original form, accompanied by English versions from the 1914 translation by H. Rackham. <br/> <br/> Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source. Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of "de Finibus Bonorum et Malorum" (The Extremes of Good and Evil) by Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular during the Renaissance. The first line of Lorem Ipsum, "Lorem ipsum dolor sit amet..", comes from a line in section 1.10.32. The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested. Sections 1.10.32 and 1.10.33 from "de Finibus Bonorum et Malorum" by Cicero are also reproduced in their exact original form, accompanied by English versions from the 1914 translation by H. Rackham.`
    },
    {
        id: 2,
        imageUrl: blogContent1,
        content: `
        Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source. Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of "de Finibus Bonorum et Malorum" (The Extremes of Good and Evil) by Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular during the Renaissance. The first line of Lorem Ipsum, "Lorem ipsum dolor sit amet..", comes from a line in section 1.10.32. The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested. Sections 1.10.32 and 1.10.33 from "de Finibus Bonorum et Malorum" by Cicero are also reproduced in their exact original form, accompanied by English versions from the 1914 translation by H. Rackham. <br/> <br/> Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source. Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of "de Finibus Bonorum et Malorum" (The Extremes of Good and Evil) by Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular during the Renaissance. The first line of Lorem Ipsum, "Lorem ipsum dolor sit amet..", comes from a line in section 1.10.32. The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested. Sections 1.10.32 and 1.10.33 from "de Finibus Bonorum et Malorum" by Cicero are also reproduced in their exact original form, accompanied by English versions from the 1914 translation by H. Rackham.`
    },
    {
        id: 3,
        imageUrl: blogContent1,
        content: `
        Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source. Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of "de Finibus Bonorum et Malorum" (The Extremes of Good and Evil) by Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular during the Renaissance. The first line of Lorem Ipsum, "Lorem ipsum dolor sit amet..", comes from a line in section 1.10.32. The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested. Sections 1.10.32 and 1.10.33 from "de Finibus Bonorum et Malorum" by Cicero are also reproduced in their exact original form, accompanied by English versions from the 1914 translation by H. Rackham.<br/> <br/> Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source. Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of "de Finibus Bonorum et Malorum" (The Extremes of Good and Evil) by Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular during the Renaissance. The first line of Lorem Ipsum, "Lorem ipsum dolor sit amet..", comes from a line in section 1.10.32. The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested. Sections 1.10.32 and 1.10.33 from "de Finibus Bonorum et Malorum" by Cicero are also reproduced in their exact original form, accompanied by English versions from the 1914 translation by H. Rackham.`
    },
    {
        id: 4,
        imageUrl: blogContent1,
        content: `
       Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source. Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of "de Finibus Bonorum et Malorum" (The Extremes of Good and Evil) by Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular during the Renaissance. The first line of Lorem Ipsum, "Lorem ipsum dolor sit amet..", comes from a line in section 1.10.32. The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested. Sections 1.10.32 and 1.10.33 from "de Finibus Bonorum et Malorum" by Cicero are also reproduced in their exact original form, accompanied by English versions from the 1914 translation by H. Rackham.<br/> <br/> Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source. Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of "de Finibus Bonorum et Malorum" (The Extremes of Good and Evil) by Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular during the Renaissance. The first line of Lorem Ipsum, "Lorem ipsum dolor sit amet..", comes from a line in section 1.10.32. The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested. Sections 1.10.32 and 1.10.33 from "de Finibus Bonorum et Malorum" by Cicero are also reproduced in their exact original form, accompanied by English versions from the 1914 translation by H. Rackham.`
    },
    {
        id: 5,
        imageUrl: blogContent1,
        content: `
       Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source. Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of "de Finibus Bonorum et Malorum" (The Extremes of Good and Evil) by Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular during the Renaissance. The first line of Lorem Ipsum, "Lorem ipsum dolor sit amet..", comes from a line in section 1.10.32. The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested. Sections 1.10.32 and 1.10.33 from "de Finibus Bonorum et Malorum" by Cicero are also reproduced in their exact original form, accompanied by English versions from the 1914 translation by H. Rackham.<br/> <br/> Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source. Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of "de Finibus Bonorum et Malorum" (The Extremes of Good and Evil) by Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular during the Renaissance. The first line of Lorem Ipsum, "Lorem ipsum dolor sit amet..", comes from a line in section 1.10.32. The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested. Sections 1.10.32 and 1.10.33 from "de Finibus Bonorum et Malorum" by Cicero are also reproduced in their exact original form, accompanied by English versions from the 1914 translation by H. Rackham.`
    },
    {
        id: 6,
        imageUrl: blogContent1,
        content: `
       Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source. Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of "de Finibus Bonorum et Malorum" (The Extremes of Good and Evil) by Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular during the Renaissance. The first line of Lorem Ipsum, "Lorem ipsum dolor sit amet..", comes from a line in section 1.10.32. The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested. Sections 1.10.32 and 1.10.33 from "de Finibus Bonorum et Malorum" by Cicero are also reproduced in their exact original form, accompanied by English versions from the 1914 translation by H. Rackham.<br/> <br/> Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source. Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of "de Finibus Bonorum et Malorum" (The Extremes of Good and Evil) by Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular during the Renaissance. The first line of Lorem Ipsum, "Lorem ipsum dolor sit amet..", comes from a line in section 1.10.32. The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested. Sections 1.10.32 and 1.10.33 from "de Finibus Bonorum et Malorum" by Cicero are also reproduced in their exact original form, accompanied by English versions from the 1914 translation by H. Rackham.`
    }
    
];

export const IconsTable = [
    {
        id: 0,
        src: smile,
        count: "count1",
        content: "content1"
    },
    {
        id: 1,
        src: city,
        count: "count2",
        content: "content2"
    }, 
    {
        id: 2,
        src: properties,
        count: "count3",
        content: "content3"
    },
    {
        id: 4,
        src: exellent,
        count: "count5",
        content: "content5"
    },
    {
        id: 3,
        src: recomended,
        count: "count4",
        content: "content4"
    },
   
]

// ReasonsTable
export const ReasonsTable = [
    {
        id: 0,
        src: apartments,
        count: "title1",
        content: "content1"
    },
    {
        id: 1,
        src: locations,
        count: "title2",
        content: "content2"
    },
    {
        id: 2,
        src: application,
        count: "title3",
        content: "content3"
    },
    {
        id: 3,
        src: inclusive,
        count: "title4",
        content: "content4"
    },
    {
        id: 4,
        src: assistance,
        count: "title5",
        content: "content5"
    },
    {
        id: 5,
        src: flexibility,
        count: "title6",
        content: "content6"
    }
]

// StepsTable
export const StepsTable = [
    {
        id: 0,
        src: stepOne,
        count: "Step1",
        content: "content1"   
    },
    {
        id: 1,
        src: stepTwo,
        count: "Step2",
        content: "content2"
    },
    {
        id: 2,
        src: stepThree,
        count: "Step3",
        content: "content3"
    },
    {
        id: 3,
        src: stepFour,
        count: "Step4",
        content: "content4"
    }
]

// ExploreCitiesTable
export const ExploreCitiesTable = [
    {
        id:0,
        src: dax,
        city:"Dax",
        count: 12
    },
   {
        id:1,
        src: mugron,
        city:"Mugron",
        count: 12
    }, 
]

// FeedbackTable
export const FeedbacksTable = [
    {
        id:0,
        src: f1,
        name:"Aurelien",
        content: "Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknownprinter "
    },
     {
        id:1,
        src: f2,
        name:"Laura",
        content: "Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknownprinter "
    },
     {
        id:2,
        src: f3,
        name:"Maria",
        content: "Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknownprinter "
    },
    {
        id:3,
        src: f4,
        name:"Fabio",
        content: "Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknownprinter "
    },
    {
        id:4,
        src: f5,
        name:"Matthew",
        content: "Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknownprinter "
    },
    {
        id:5,
        src: f8,
        name:"Megan",
        content: "Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknownprinter "
    },
    {
        id:6,
        src: f7,
        name:"Francesca",
        content: "Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknownprinter "
    },
{
   id:7,
   src: f6,
   name:"Jason",
   content: "Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknownprinter "
},
]


// CribsTable
export const CribesTable =[
    {
        id:0,
        src: [
        {
            id:0,
            src_room:room_city
        },
        {
            id:1,
            src_room:room_city
        },
        {
            id:2,
            src_room:room_city
        },
        {
            id:3,
            src_room:room_city
        }
    ],
        name:"Nom et prenom",
        content: "12 Villebois Mareuil - Chambre 2 ",
        adress: "47 rue Pierre Audry, 69009 Lyon",
        price: "574$"
    },
    {
        id:1,
        src: [
            {
                id:0,
                src_room:room_city
            },
            {
                id:1,
                src_room:room_city
            },
            {
                id:2,
                src_room:room_city
            },
            {
                id:3,
                src_room:room_city
            }
        ],
        name:"Nom et prenom",
        content: "12 Villebois Mareuil - Chambre 2 ",
        adress: "47 rue Pierre Audry, 69009 Lyon",
        price: "574$"

    },
    {
        id:2,
        src: [
            {
                id:0,
                src_room:room_city
            },
            {
                id:1,
                src_room:room_city
            },
            {
                id:2,
                src_room:room_city
            },
            {
                id:3,
                src_room:room_city
            }
        ],
        name:"Nom et prenom",
        content: "12 Villebois Mareuil - Chambre 2 ",
        adress: "47 rue Pierre Audry, 69009 Lyon",
        price: "574$"

    },
    {
        id:3,
        src: [
            {
                id:0,
                src_room:room_city
            },
            {
                id:1,
                src_room:room_city
            },
            {
                id:2,
                src_room:room_city
            },
            {
                id:3,
                src_room:room_city
            }
        ],
        name:"Nom et prenom",
        content: "12 Villebois Mareuil - Chambre 2 ",
        adress: "47 rue Pierre Audry, 69009 Lyon",
        price: "574$"

    },
    {
        id:4,
        src: [
            {
                id:0,
                src_room:room_city
            },
            {
                id:1,
                src_room:room_city
            },
            {
                id:2,
                src_room:room_city
            },
            {
                id:3,
                src_room:room_city
            }
        ],
        name:"Nom et prenom",
        content: "12 Villebois Mareuil - Chambre 2 ",
        adress: "47 rue Pierre Audry, 69009 Lyon",
        price: "574$"
    },
    {
        id:5,
        src: [
            {
                id:0,
                src_room:room_city
            },
            {
                id:1,
                src_room:room_city
            },
            {
                id:2,
                src_room:room_city
            },
            {
                id:3,
                src_room:room_city
            }
        ],
        name:"Nom et prenom",
        content: "12 Villebois Mareuil - Chambre 2 ",
        adress: "47 rue Pierre Audry, 69009 Lyon",
        price: "574$"

    },

]

// UploadTable
export const UploadArray = [
    {
        id:0,
        heading: " Looking to speed up the booking process?  Save time by completing your file now(optional)",
        src: upload,
        content: "Upload identity card"
    },

    {
        id:1,
        heading: "Are you a student?",
        src: certificate,
        content: "image-gallery.svg"
    },

    {
        id:2,
        heading: "",
        src: groupId,
        content: "Your guarantor’s ID"
    },
    {
        id:3,
        heading: "",
        src: payslip,
        content: "Your guarantor’s last payslip or tax return"
    },
    {
        id:4,
        heading: "Are you a professional ?",
        src: inVoice,
        content: "Upload your last payslip or tax declaration"
    }
]


// FaqspageTableRenting
export const FaqspageTableRenting = [
{
    id:0,
    title:"titre1",
    subTitles:[
        {
        id:0,
        title:"t1question1",
        answer:"t1q1reponse",  
        src:""
    },
    {
        id:1,
        title:"t1question2",
        answer:"t1q2reponse",  
        src:""
    },
    {
        id:2,
        title:"t1question3",
        answer:"t1q3reponse",  
        src:""
    },
    {
        id:3,
        title:"t1question4",
        answer:"t1q4reponse",  
        src:""
    },
    {
        id:4,
        title:"t1question5",
        answer:"t1q5reponse",  
        src:""
    }
   ]   
},
{
    id:1,
    title:"titre2",
    subTitles:[
        {
        id:0,
        title:"t2question1",
        answer:"t2q1reponse",  
        src:""
    },
    {
        id:1,
        title:"t2question2",
        answer:"t2q2reponse",  
        src:""
    },
    {
        id:2,
        title:"t2question3",
        answer:"t2q3reponse",  
        src:""
    },
    {
        id:3,
        title:"t2question4",
        answer:"t2q4reponse",  
        src:""
    },
    {
        id:4,
        title:"t2question5",
        answer:"t2q5reponse",  
        src:""
    },
    {
        id:5,
        title:"t2question6",
        answer:"t2q6reponse",  
        src:""
    },
    {
        id:6,
        title:"t2question7",
        answer:"t2q7reponse",  
        src:""
    },
    {
        id:7,
        title:"t2question8",
        answer:"t2q8reponse",  
        src:""
    },

   ]   
},
{
    id:2,
    title:"titre3",
    subTitles:[
    {
        id:0,
        title:"t3question1",
        answer:"t3q1reponse",  
        src:""
    },
    {
        id:1,
        title:"t3question2",
        answer:"t3q2reponse",  
        src:""
    },
    {
        id:2,
        title:"t3question3",
        answer:"t3q3reponse",  
        src:""
    },
    {
        id:3,
        title:"t3question4",
        answer:"t3q4reponse",  
        src:""
    },
    {
        id:4,
        title:"t3question5",
        answer:"t3q5reponse",  
        src:""
    },
 ] 
},
{
    id:3,
    title:"titre4",
    subTitles:[
    {
        id:0,
        title:"t4question1",
        answer:"t4q1reponse",  
        src:""
    },
    {
        id:1,
        title:"t4question2",
        answer:"t4q2reponse",  
        src:""
    },
    {
        id:2,
        title:"t4question3",
        answer:"t4q3reponse",  
        src:""
    },
    {
        id:3,
        title:"t4question4",
        answer:"t4q4reponse",  
        src:""
    },
    {
        id:4,
        title:"t4question5",
        answer:"t4q5reponse",  
        src:""
    },
    {
        id:5,
        title:"t4question6",
        answer:"t4q6reponse",  
        src:""
    },
    {
        id:6,
        title:"t4question7",
        answer:"t4q7reponse",  
        src:""
    },
    {
        id:7,
        title:"t4question8",
        answer:"t4q8reponse",  
        src:""
    },
    {
        id:8,
        title:"t4question9",
        answer:"t4q9reponse",  
        src:""
    },
    {
        id:9,
        title:"t4question10",
        answer:"t4q10reponse",  
        src:""
    },
    {
        id:10,
        title:"t4question11",
        answer:"t4q11reponse",  
        src:""
    },
   ]  
  
},
{
    id:4,
    title:"titre5",
    subTitles:[
    {
        id:0,
        title:"t5question1",
        answer:"t5q1reponse",  
        src:""
    },
    {
        id:1,
        title:"t5question2",
        answer:"t5q2reponse",  
        src:""
    },
    {
        id:2,
        title:"t5question3",
        answer:"t5q3reponse",  
        src:""
    },
    {
        id:3,
        title:"t5question4",
        answer:"t5q4reponse",  
        src:""
    },
    {
        id:4,
        title:"t5question5",
        answer:"t5q5reponse",  
        src:""
    },
    {
        id:5,
        title:"t5question6",
        answer:"t5q6reponse",  
        src:""
    },
   ]   
},
{
    id:5,
    title:"titre6",
    subTitles:[
    {
        id:0,
        title:"t6question1",
        answer:"t6q1reponse",  
        src:""
    },
    {
        id:1,
        title:"t6question2",
        answer:"t6q2reponse",  
        src:""
    },
    {
        id:2,
        title:"t6question3",
        answer:"t6q3reponse",  
        src:""
    },
    {
        id:3,
        title:"t6question4",
        answer:"t6q4reponse",  
        src:""
    },
    {
        id:4,
        title:"t6question5",
        answer:"t6q5reponse",  
        src:""
    },
    {
        id:5,
        title:"t6question6",
        answer:"t6q6reponse",  
        src:""
    },
   ]   
}
]
// FaqspageTablePartnering
export const FaqspageTablePartnering = [
    {
        id:0,
        title:"Help you decide",
        subTitles:[
            {
            id:0,
            title:"Why should I trust Finecribs?",
            answer:`<p>There are several reasons why you should choose to partner with us: </p>
            <ul style="list-style:none;margin:0;padding:0;"><li><strong>Our interests are aligned:</strong> We understand your perspective as a landlord because we are landlords ourselves. We manage your property with the same care and attention we give to our own investments.</li>
            <li><strong>Steady Rental Payments:</strong> You rent your property to Landes Location. In exchange, we provide you with a steady rental payment, even if your apartment is temporarily unoccupied, offering you peace of mind and financial stability.<br/>
            Our comprehensive approach aims to make property management hassle-free, profitable, and secure for you as a landlord. </li>
            <li><strong>Tenant Selection:</strong> We have a rigorous tenant selection process, ensuring that only qualified and reliable tenants are chosen for your property.</li>
            <li><strong>Professional Maintenance:</strong> Our teams of qualified professionals oversee ongoing maintenance for your apartment, ensuring it remains in top condition.</li>
            </ul>`,  
            src:""
        },
        {
            id:1,
            title:"How long will Finecribs rent my property?", 
            answer:`<p>In general, Landes Location seeks to establish long-term lease agreements with individual property owners. We typically prefer to secure properties for a minimum of 7 years, and we ideally favor even longer lease periods. This long-term commitment allows for stability and mutually beneficial arrangements for both Landes Location and property owners.</p>`,  
            src:""
        },
        {
            id:2,
            title:"Who will stay in my apartment?",
            answer:`<p>We take pride in offering high-quality accommodation to a discerning audience of carefully selected international tenants, primarily consisting of young professionals. Our thorough application review process ensures that only the most suitable profiles are accepted, maintaining the standards of our properties.</p>
            <p>Our commitment to excellence means that your interests as a property owner are consistently aligned with our mission to provide exceptional housing options. This alignment results in a win-win scenario for both property owners and Landes Location.</p>`,  
            src:"" 
        },
        {
            id:3,
            title:"Should my apartment be furnished or unfurnished?",
            answer:`<p>Typically, we aim to install at least a kitchen in our properties. We generally prefer unfurnished lettings because they provide our interior designers with the flexibility to design the space according to our standards. However, we also accept properties with a minimum level of furnishing, ensuring that the space meets our requirements and quality standards.</p>`,  
            src:""
        },
        {
            id:4,
            title:"What happens if Finecribs finds no tenants?",
            answer:`<p>You will continue to receive a monthly rent from Landes Location, which means that there will be no significant change in your rental income. This consistency in rental payments provides you with financial stability and peace of mind as a property owner.</p>`,  
            src:""
        },
        {
            id:5,
            title:"What happens if a tenant damages the property?",
            answer:`<p>Landes Location, as tenant, is liable to the property owner for any damage caused by a tenant. Of course, we also get insurance, and we request all our tenants to do the same.</p>`,  
            src:""
        },
        {
            id:6,
            title:"What do you mean by «smart refurbishment»?",
            answer:`<p>If your property requires minor refurbishments such as repainting, bathroom renovations, or the construction of a plastered wall, our teams can handle these tasks at no additional cost to you. Any necessary initiatives of this nature will be considered in the offer we provide to you, ensuring that your property is maintained and improved as needed without incurring extra expenses on your part.</p>`,  
            src:""
        },
        {
            id:7,
            title:"How do I know if my proerty qualifies?",
            answer:"<p>You should submit a request through the form and our team will contact you to assess together whether your property qualifies. Typically, we look for properties in central locations, with at least three bedrooms and in overall good conditions.</p>",  
            src:""
        },
        {
            id:8,
            title:"Do you rent of also buy properties?",
            answer:"<p>Our core expertise lies in acquiring, designing and managing beautiful spaces. In case you are uncertain whether to rent or sell your property we would be happy to discuss and possibly make an offer for acquiring the property instead of renting it.</p>",  
            src:""
        }
       ]   
    }
]
